import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BoxxImagePickerMobileCamera } from './lib/classes/ImagePickerMobileCamera';
import { BoxxImagePickerMobilePicker } from './lib/classes/ImagePickerMobilePicker';
import { BoxxImagePickerPWAPicker } from './lib/classes/ImagePickerPWAPicker';
import { BoxxImageFixerComponent } from './lib/components/image-fixer/invalid-images-fixer.component';
import { BoxxImagePickerSourceService } from './lib/services/image-picker-source';
import { BoxxImageUtils } from './lib/utils/imageUtils';
import { TranslateModule } from '@ngx-translate/core';
import { BoxxImageDetailComponent } from './lib/components/image-detail/image-detail.component';


@NgModule({
  declarations: [BoxxImageFixerComponent, BoxxImageDetailComponent],
  imports: [CommonModule, IonicModule, TranslateModule.forChild(),],
  exports: [BoxxImageFixerComponent, BoxxImageDetailComponent],
  providers: [
    BoxxImagePickerPWAPicker,
    BoxxImagePickerMobileCamera,
    BoxxImagePickerMobilePicker,
    BoxxImageUtils,
    BoxxImagePickerSourceService,
    BoxxUtilsService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BoxxImagesModule {}
